const JAHR_DES_GEBOTSTERMIN_REQUIRING_GEBOTSTERMIN = [2025];

/** Returns whether the given Jahr des Gebotstermins requires an exact Gebotstermin. */
function getNeedsGebotstermin(jahrDesGebotstermins: number): boolean {
  return JAHR_DES_GEBOTSTERMIN_REQUIRING_GEBOTSTERMIN.includes(
    jahrDesGebotstermins
  );
}

export { getNeedsGebotstermin };
